import { permissionsElement } from '../../constants/permissions-list';
import { SideNavInterface } from '../../interfaces/side-nav.type';

export const ROUTES: SideNavInterface[] = [
  {
    path: '/dashboard/home',
    title: 'Tableau de bord',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'dashboard',
    permissions: ['all'],
    submenu: [],
  },
  {
    path: '/dashboard/quiz',
    title: 'Gestion Quiz',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'build',
    permissions: permissionsElement.quiz,
    submenu: [
      {
        path: '/dashboard/quiz/quizzes',
        title: 'Gerer mes quiz',
        iconType: '',
        icon: '',
        iconTheme: '',
        permissions: [
          'canOnlyCreateQuiz',
          'canOnlyUpdateQuiz',
          'canOnlyDeleteQuiz',
          'canOnlyReadQuiz',
          'canDoAllQuiz',
          ...permissionsElement.quiz,
          'root',
        ],
        submenu: [],
      },
      {
        path: '/dashboard/quiz/questions',
        title: 'Gerer mes questions',
        iconType: '',
        icon: '',
        iconTheme: '',
        permissions: [
          'canOnlyCreateQuestion',
          'canOnlyUpdateQuestion',
          'canOnlyDeleteQuestion',
          'canOnlyReadQuestion',
          'canDoAllQuestions',
          'root',
          ...permissionsElement.question,
        ],
        submenu: [
          // {
          //   path: '/dashboard/quiz/questions/view',
          //   title: "Vue d'ensemble",
          //   iconType: '',
          //   icon: '',
          //   iconTheme: '',
          //   submenu: [],
          // },
          // {
          //   path: '/dashboard/quiz/questions/add',
          //   title: 'Ajouter',
          //   iconType: '',
          //   icon: '',
          //   iconTheme: '',
          //   submenu: [],
          // },
          // {
          //   path: '/dashboard/quiz/questions/edit',
          //   title: 'Modifier',
          //   iconType: '',
          //   icon: '',
          //   iconTheme: '',
          //   submenu: [],
          // },
        ],
      },
      {
        path: '/dashboard/quiz/packs/',
        title: 'Gerer mes packs',
        iconType: '',
        icon: '',
        iconTheme: '',
        submenu: [],
        permissions: [
          'canOnlyCreatePack',
          'canOnlyUpdatePack',
          'canOnlyDeletePack',
          'canOnlyReadPack',
          'canDoAllPack',
          'root',
          ...permissionsElement.pack,
        ],
      },
      {
        path: '/dashboard/quiz/promotions',
        title: 'Gerer mes promotions',
        iconType: '',
        icon: '',
        iconTheme: '',
        submenu: [],
        permissions: [
          'canOnlyCreatePromotion',
          'canOnlyUpdatePromotion',
          'canOnlyDeletePromotion',
          'canOnlyReadPromotion',
          'canDoAllPromotions',
          'canDoAllUsers',
          'root',
        ],
      },
      {
        path: '/dashboard/quiz/rewards',
        title: 'Gerer mes recompenses',
        iconType: '',
        icon: '',
        iconTheme: '',
        submenu: [],
        permissions: [...permissionsElement.reward, 'canDoAllRewards'],
      },
      // {
      //   path: '/dashboard/quiz/history',
      //   title: 'Historique de quiz',
      //   iconType: '',
      //   icon: '',
      //   permissions: ['canDoAllHistory', 'root'],
      //   iconTheme: '',
      //   submenu: [],
      // },
      {
        path: '/dashboard/quiz/subs',
        title: 'Gerer mes souscriptions',
        iconType: '',
        icon: '',
        permissions: [...permissionsElement.subs],
        iconTheme: '',
        submenu: [],
      },
    ],
  },
  {
    path: '/dashboard/players',
    title: 'Gestion des joueurs',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'rise',
    permissions: [
      'canOnlyCreateplayer',
      'canOnlyUpdateplayer',
      'canOnlyDeleteplayer',
      'canOnlyReadplayer',
      'canDoAllPlayers',
      ...permissionsElement.player,
    ],
    submenu: [
      {
        path: '/dashboard/players/view',
        title: "Vue d'ensemble",
        iconType: '',
        icon: '',
        iconTheme: '',
        permissions: ['canDoAllPlayers', 'canOnlyReadplayer', 'root'],
        submenu: [],
      },
      {
        path: '/dashboard/players/rankings',
        title: 'Classement',
        iconType: '',
        icon: '',
        iconTheme: '',
        permissions: ['canDoAllPlayers', 'canOnlyReadplayer', 'root'],
        submenu: [],
      },
    ],
  },
  {
    path: '/dashboard/users',
    title: 'Gestion utilisateurs',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    permissions: ['canDoAllUsers', ...permissionsElement.user, 'root'],
    submenu: [
      {
        path: '/dashboard/users/view',
        title: "Vue d'ensemble",
        iconType: '',
        icon: '',
        iconTheme: '',
        permissions: ['canDoAllUsers', ...permissionsElement.user, 'root'],
        submenu: [],
      },
      {
        path: '/dashboard/users/permissions',
        title: 'Permissions et rôle',
        iconType: '',
        permissions: ['canDoAllUsers'],
        icon: '',
        iconTheme: '',
        submenu: [],
      },
    ],
  },
  {
    path: '/dashboard/payment-mode',
    title: 'Mode de paiement',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'transaction',
    permissions: [...permissionsElement.paymentMode],
    submenu: [
      {
        path: '/dashboard/payment-mode/view',
        title: "Vue d'ensemble",
        iconType: '',
        icon: '',
        iconTheme: '',
        permissions: [...permissionsElement.paymentMode],
        submenu: [],
      },
    ],
  },
  {
    path: '/dashboard/fournisseurs',
    title: 'Gestion fournisseurs',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'audit',
    permissions: [...permissionsElement.paymentMode],
    submenu: [
      {
        path: '/dashboard/fournisseurs/view',
        title: "Vue d'ensemble",
        iconType: '',
        icon: '',
        iconTheme: '',
        permissions: [...permissionsElement.paymentMode],
        submenu: [],
      },
    ],
  },
  {
    path: '/dashboard/guest',
    title: 'Espace Invité',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'container',
    permissions: [...permissionsElement.guest,...permissionsElement.paymentMode],
    submenu: [
      {
        path: '/dashboard/guest',
        title: "Vue d'ensemble",
        iconType: '',
        icon: '',
        iconTheme: '',
        permissions: [...permissionsElement.paymentMode],
        submenu: [],
      },
    ],
  },
  // {
  //   path: '/dashboard/revenues',
  //   title: 'Rapport Financier',
  //   iconType: 'nzIcon',
  //   iconTheme: 'outline',
  //   icon: 'calculator',
  //   permissions: ['canDoAllUsers', 'root'],
  //   submenu: [],
  // },
];
